import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {clearCashAppOrder} from '../../../../reducers/app/actions';
import PageLoader from '../../../components/loader_page';

export default ({order}) => {
    const navigate = useNavigate(),
          dispatch = useDispatch();

    if(!order)
        return <PageLoader />;

    return (
        <>
            <div className="alert">
                <div className="icon">
                    ✅
                </div>

                <div className="mt10"></div>
                <div className="title">CashApp</div>
                <div className="text">Your request for a <b>${order.amount}</b> deposit is being processed! If you did everything correctly, it will take 1 minute.</div>
            
                <div className="mt40"></div>

                <div className="big-text">Unique Payment ID: <span className="text-green">{order.paymentId}</span></div>
            </div>

            <div className="button" onClick={e => {
                dispatch(clearCashAppOrder());
                navigate('/');
            }}>Okay, thanks!</div>
        </>
    )
}